import { showMessage } from 'services/settings/message';
import { axiosLabAPI } from 'services/axios';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';

export default async function fetchExamList(sectionId, specimenId, silentFlag = false) {
	let examList = null;
	const url = `settings/examitem`
	const params= {
		p_section_id: sectionId,
		p_specimen_id: specimenId
	}
	try {
		const content = {
			method: API_GET_METHOD,url, params};

		const response = await axiosLabAPI(content);
		const { data } = await response;

		examList = data.RECORDS;
	} catch (e) {
		if(!silentFlag){
			showMessage(e);
		}
		// console.log('test fetchExamList =>')
	}

	return examList;
}

export async function fetchSections() {
	let sections = [];

	try {
		const url = `listofvalues/section`;

		const response = await axiosLabAPI({ method: API_GET_METHOD, url });
		const { data } = await response;

		sections = data.RECORDS;
	} catch (e) {
		showMessage(e);
	}

	return sections;
}

export async function fetchSpecimens() {
	let specimens = [];

	try {
		const url = `listofvalues/specimen`;

		const response = await axiosLabAPI({ method: API_GET_METHOD, url });
		const { data } = await response;

		specimens = data.RECORDS;
	} catch (e) {
		showMessage(e);
	}

	return specimens;
}

export async function fetchExamitems(sectionId, specimenId) {
	let examItems = [];
		// const url = `lab/ExamItem/Settings/SectionID/${sectionId}/SpecimenID/${specimenId}?actv=1`;
		const url = `settings/examitem`;
		const params = {
			p_section_id: sectionId,
			p_specimen_id: specimenId
		};

	try {

		const response = await axiosLabAPI({ method: API_GET_METHOD, url, params });
		const { data } = await response;

		examItems = data.RECORDS || [];
	} catch (e) {
		showMessage(e);
	}

	return examItems;
}

export async function fetchExamItem(scid, spid, emid) {
	let examItem = null;
	const url = `settings/examitem`;
	const params = {
		p_section_id: scid,
		p_specimen_id: spid,
		p_exam_item_id: emid
	}


	try {
		// const url = `/lab/ExamItem/Settings/SectionID/${scid}/SpecimenID/${spid}/ExamItemID/${emid}`;

		const response = await axiosLabAPI({ method: API_GET_METHOD, url, params });
		const { data } = await response;

		examItem = data.RECORDS.at(0) || null;
	} catch (e) {
		showMessage(e);
	}

	return examItem;
}

export async function createExamItem(examItem) {
	let createdExamItem;
	const url = `settings/examitem`;

	const {
		examItemName, examItemGeneralName, examItemTypeCode,
		examItemIntegrationCode, examItemUnitCode, examItemValue,
		sectionID,specimenID,active,examItemAnalayzereCodes, examItemSort
	} = examItem;

	try {
		const content = {
			method: API_POST_METHOD,
			url,
			data: {
				p_exam_item_name: examItemName,
				p_exam_item_general_name: examItemGeneralName,
				p_exam_item_type_code: examItemTypeCode,
				p_exam_item_analyzer_codes: examItemIntegrationCode,
				p_exam_item_unit_code: examItemUnitCode,
				p_section_id: sectionID,
				p_specimen_id: specimenID,
				p_active: active,
				p_exam_item_sort: examItemSort || 1,
				p_exam_item_value_array: JSON.stringify(examItemValue),
				p_exam_item_analyzer_codes_array: JSON.stringify(examItemAnalayzereCodes)
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = await response;

		createdExamItem = data;
	} catch (e) {
		showMessage(e);
	}

	return createdExamItem;
}

export async function updateExamItem(examItem) {
	let updatedExamItem;
	const url = `settings/examitem`;
	const {
		examItemId,examItemName,examItemGeneralName,
		examItemTypeCode,examItemIntegrationCode,examItemUnitCode,examItemValue,
		sectionID,specimenID,active,examItemAnalayzereCodes, examItemSort
	} = examItem;


	try {
		const content = {
			method: API_PUT_METHOD,
			url,
			data: {
  				p_exam_item_id: examItemId,
  				p_exam_item_name: examItemName,
  				p_exam_item_general_name: examItemGeneralName,
  				p_exam_item_type_code: examItemTypeCode,
  				p_exam_item_analyzer_codes: examItemIntegrationCode,
  				p_exam_item_unit_code: examItemUnitCode,
  				p_section_id: sectionID,
  				p_specimen_id: specimenID,
  				p_active: active,
  				p_exam_item_sort: examItemSort || 1,
  				p_exam_item_value_array: JSON.stringify(examItemValue),
  				p_exam_item_analyzer_codes_array: JSON.stringify(examItemAnalayzereCodes)
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = await response;

		updatedExamItem = data.RECORDS;
	} catch (error) {
		showMessage(error);
	}

	return updatedExamItem;
}

export async function applySorting(payload) {
	let sortResponse;
	const url = `settings/examitemsort`
	try {
		const content = {
			method: API_PUT_METHOD,
			url,
			// url: '/lab/ExamItem/Settings/ExamResultSorting',
			data: {
				p_exam_item_sorting_array: JSON.stringify(payload)
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = await response;

		sortResponse = data;
	} catch (error) {
		showMessage(error);
	}

	return sortResponse;
}
